export interface OrderProcessedToSave {
    ClientMail: string
    ClientName: string
    ClientPhone: string
    DoorSizeId?: number
    Alias: any
    LockerId?: number
    ClientData?: DataSentByAddress
    DepositCode?: string | null
    RowNumber: number
    CustomSecurity?: CustomSecurityData
}

export interface OrderImportedFromXLS {
    ClientMail: string
    ClientName: string
    ClientPhone: string
    Alias: any
    LockerId: number
    ParcelLengthInMm?: number
    ParcelWidthInMm?: number
    ParcelHeightInMm?: number
    ParcelWeightInGrams?: number
    StreetName?: string
    StreetNumber?: string
    Floor?: string
    City?: string
    CountrySubdivision?: string
    PostalCode?: string
    Apartment?: string
    Locality?: string
    DepositCode?: string | null
    Error?: ErrorSheet[]
    SaveError?: ErrorSheet[]
    Result?: string
    RequestSignature?: string
    RequestToken?: string
    CustomCodeType?: string | undefined,
    CustomCode?: string | number | undefined,
}

// TODO: Tal vez todo lo referido a DoorSize debería llamarse LockerSize
export enum DoorSize {
    xs = 8,
    s = 4,
    m = 5,
    l = 6,
    xl = 7,
    error = -1,
}

export interface Locker {
    id: number
    name: string
    locationDetails: string
    latitude: string
    longitude: string
    locationAddress: string
    city: string
    country: string
    province: string
    zipCode: string
}

export interface DataSentByLocker {
    DoorSizeId: DoorSize
    parcelHeightInMm: number
    parcelLengthInMm: number
    parcelWidthInMm: number
    parcelWeightInGrams: number
}

export interface DataSentByAddress {
    StreetName?: string
    StreetNumber?: string
    Floor?: string
    City?: string
    CountrySubdivision?: string
    PostalCode?: string
    Apartment?: string
    Locality?: string
}

export interface CustomSecurityData {
    RequestSignature?: string
    RequestToken?: string
    CustomCode?: {
        Type?: number | undefined,
        Code?: string | number | undefined,
    },
}

export enum DoorSizeText {
    ExtraSmall = 'XS',
    Small = 'S',
    Medium = 'M',
    Large = 'L',
    ExtraLarge = 'XL',
}

// TODO: DoorLengthInterface, DoorHeightInterface, DoorWidthInterface quedan obsoletas
export enum DoorLengthInterface {
    ExtraSmall = 520,
    Small = 520,
    Medium = 520,
    Large = 520,
    ExtraLarge = 520,
}

export enum DoorHeightInterface {
    ExtraSmall = 85,
    Small = 55,
    Medium = 140,
    Large = 310,
    ExtraLarge = 680,
}

export enum DoorWidthInterface {
    ExtraSmall = 140,
    Small = 320,
    Medium = 320,
    Large = 320,
    ExtraLarge = 320,
}

export interface LockerDimensionsInterface {
    id: DoorSizeText
    sizeNumber: number
    height: number
    width: number
    length: number
}

export interface ErrorSheet {
    row: any
    message: string
}
